<div class="filter-panel" *ngIf="filterService.filters$ | async as filters">
  <div class="panel-header">
    <h3>Filter</h3>
    <button mat-stroked-button color="primary" (click)="resetFilters()">Zurücksetzen</button>
  </div>

  <div class="filter-content">
    <div class="filter-group">
      <label class="group-label">Mindestbewertung</label>
      <div class="star-rating-input">
        @for (star of [1, 2, 3, 4, 5]; track star) {
          <mat-icon (click)="setRating(star)" (mouseenter)="hoverRating = star" (mouseleave)="hoverRating = 0">
            {{ (hoverRating || filters.minRating || 0) >= star ? 'star' : 'star_border' }}
          </mat-icon>
        }
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="filter-group">
      <label class="group-label">Eigenschaften</label>
      <div class="toggle-grid">
        @for (t of toggles; track t.key) {
          <button
            mat-button
            class="toggle-button"
            [class.active]="isActive(t.key)"
            (click)="toggleFilter(t.key)"
            [attr.aria-pressed]="isActive(t.key)"
          >
            <span class="toggle-button-content">
              <mat-icon>{{ t.icon }}</mat-icon>
              <span class="label">{{ t.label }}</span>
            </span>
          </button>
        }
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="filter-group">
      <label class="group-label">Max. Preis</label>
      <div class="price-input-wrapper">
        <input
          type="number"
          class="price-input"
          placeholder="Egal"
          [value]="filters.price ?? ''"
          min="0"
          step="0.5"
          (input)="setPrice($any($event.target).value ? +$any($event.target).value : null)"
        />
        <button
          mat-icon-button
          class="clear-button"
          aria-label="Preisfilter löschen"
          (click)="setPrice(null)"
          *ngIf="filters.price !== null && filters.price !== undefined"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="panel-footer">
    <button mat-flat-button color="primary" (click)="layoutService.toggleFilters()">Filter anwenden</button>
  </div>
</div>
